import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { breakpoints } from '@/config/layout'

import type { PartiallyRequired } from '@/utils/typescript'
import type { ActivityCardProps } from './ActivityCard.types'

const StActivityCardContainer = styled.div<
  PartiallyRequired<ActivityCardProps, 'type' | 'showColorBorder' | 'completed'> & {
    selected: boolean
    monotone: boolean
  }
>`
  ${({ theme, type, hasPassed, monotone, showColorBorder, selected, completed }) => {
    return `
      position: relative;
      width: 100%;
      color: ${theme.Components.Card.Text};
      background-color: ${theme.Components.Card.Fill};

      display: flex;
      flex-direction: column;
      gap: ${theme.UI.SpacingPx.Space3};

      border-width: 1px;
      border-style: solid;
      border-radius: ${theme.UI.BorderRadius.Large}px;
      border-color: ${
        monotone
          ? theme.Components.Card.Border
          : hasPassed
            ? theme.Colors.Neutrals.Light
            : theme.Colors.Category[type as keyof typeof theme.Colors.Category]
      };
      padding: ${theme.UI.SpacingPx.Space4};
      overflow: hidden;

      @media ${breakpoints.s} {
        border-width: 2px;
        border-color: ${
          monotone
            ? theme.Components.Card.Border
            : selected
              ? theme.Colors.Category[type as keyof typeof theme.Colors.Category]
              : theme.Components.Card.Border
        };

        ${
          completed
            ? null
            : `&:hover {
                border-color: ${selected ? null : theme.Colors.Neutrals.Light};
                cursor: pointer;
              }`
        }

      }

      ${
        showColorBorder
          ? `
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 6px;
        height: 100%;
        opacity: ${hasPassed ? 0.3 : 1};
        background-color: ${
          monotone ? theme.Components.Card.Border : theme.Colors.Category[type as keyof typeof theme.Colors.Category]
        };
      }
      `
          : null
      }
    `
  }}
`

const StActivityCardContent = styled(FlexColumn)`
  gap: 4px;
`

const StActivityCardIcon = styled(FontAwesomeIcon)`
  position: absolute;
  bottom: 20px;
  right: 24px;
`

const StDescription = styled(Span)<{ color?: string }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ color }) => color};
`

export { StActivityCardContainer, StActivityCardContent, StActivityCardIcon, StDescription }
